import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalButton,
  CancelButton,
  ModalDeleteButton,
} from "./trash.styles";
import trash from "../../assets/icons/Trash.png";

const deleteModal = ({
  isVisible,
  onDelete,
  onClose,
}: {
  isVisible: boolean;
  onDelete: () => void;
  onClose: () => void;
}) => {
  if (!isVisible) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <div>
          <h2>Delete Payment Link</h2>
          <p>Are you sure you want to delete the payment link?</p>
        </div>
        <ModalButton>
          <CancelButton onClick={onClose}>No, Cancel</CancelButton>
          <ModalDeleteButton onClick={onDelete}>Yes, Delete</ModalDeleteButton>
        </ModalButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default deleteModal;
